import NewHome from '.'

const NewHomeRoute = {
  path: '/new-home',
  component: NewHome,
}

export default NewHomeRoute
